import axios from "axios";

let endpoint = process.env.ENDPOINT;

// If "ENDPOINT_ALT" is provided, divide across origins for high capacity events.
if (
  process.env.ENDPOINT_ALT &&
  process.env.ENDPOINT_ALT !== "disabled" &&
  Math.random() > 0.5
) {
  endpoint = process.env.ENDPOINT_ALT;
}

const instance = axios.create({
  baseURL: endpoint
});

instance.interceptors.response.use(
  response => response,
  error => {
    let processedError = error?.response?.data?.error || error;
    processedError.originalError = error;
    return Promise.reject(processedError);
  }
);

const CACHE_EXPIRY = 1000 * 30;
const tenantCache = {};
const requestCache = {};
export const fetchTenantConfig = tenant => {
  if (tenant === "favicon.ico") {
    throw new Error("Invalid tenant");
  }

  return new Promise((resolve, reject) => {
    if (!tenant) {
      resolve({});
    } else if (requestCache[tenant]) {
      requestCache[tenant].push([resolve, reject]);
    } else if (tenantCache[tenant] && tenantCache[tenant].exp > Date.now()) {
      resolve(tenantCache[tenant].value);
    } else {
      requestCache[tenant] = [[resolve, reject]];
      axios
        .get(`${endpoint}_frontend/tenants/${tenant}`)
        .then(r => {
          const pendingRequests = requestCache[tenant];
          delete requestCache[tenant];
          if (r.headers["content-type"].indexOf("application/json") === -1) {
            pendingRequests.forEach(([resolve, reject]) =>
              reject(new Error("Site not found"))
            );
          } else {
            const tenantConfig = {
              tenant: r.data.name, // the API response is slightly different than what the watch site expects
              ...r.data.config
            };

            tenantCache[tenant] = {
              exp: Date.now() + CACHE_EXPIRY,
              value: tenantConfig
            };
            pendingRequests.forEach(([resolve, reject]) =>
              resolve(tenantConfig)
            );
          }
        })
        .catch(e => {
          const pendingRequests = requestCache[tenant];
          delete requestCache[tenant];
          pendingRequests.forEach(([resolve, reject]) => reject(e));
        });
    }
  });
};

export const recordEvent = async (event, payload = {}, attempt = 0) => {
  try {
    await axios.post("/api/play", {
      event,
      payload: JSON.stringify(payload)
    });
  } catch (e) {
    console.log("Failed to record event", e);
    if (attempt < 3) {
      setTimeout(() => {
        recordEvent(event, payload, attempt + 1);
      }, Math.random() * 2000 + 1000);
    } else {
      console.log(" ==> not retrying; attempts exceeded");
    }
  }
};

export const recordConversionEvent = async ({ email, eventType, price, currency, tenant }) => {
  try {
    await axios({
      method: "post",
      url: `${endpoint}meta/record_conversion`,
      headers: {
        Authorization: "Basic " + Buffer.from(`${tenant.api_key}:`).toString('base64')
      },
      data: {
        pixel_id: "648382377723787",
        email: email,
        event_type: eventType,
        price: price === 0 ? 0 : price ? price : null,
        currency: currency
      }
    });
  } catch (e) {
    console.log("Failed to record conversion", e);
  }
};

export default instance;
